import React from 'react'
import LeadCompanies from './companies'
import LeadCompaniesIndividual from './companiesIndividual'

function CompanyMain() {
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role?.role_id

  // console.log(role)
  return <>{role === 1 || role === 2 ? <LeadCompanies /> : <LeadCompaniesIndividual />}</>
}

export default CompanyMain
